import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import MainView from './app/MainView'

export default class Main {

	preloadJSON( dataURL) {

		let data  = {"type" : "getData", "params" : {}}
	    fetch("/api/app.php", {
	      method: "POST",
	      body: JSON.stringify(data)
	    })
	    .then((response) => {
	        return response.json()
	    })
	    .then((result) => {
	      this.data = result
	      this.ready()
	    }, (error) => {
	      console.log(error)
	    })
	}

	pageDataLoaded( data ) {
		try {
			this.data = JSON.parse(data.response)
		} catch(e) {
			alert("Upss! JSON")
			console.log(e)
	        return false
		}
		this.ready()
	}

	init() {
		this.preloadJSON("/data/data.json")
	}

	ready() {
		this.render()
	}

	render() {
		document.getElementById('preloader').className = "hide"
		const mainContainer = document.getElementById('app')

		ReactDOM.render(
			<Router>
				<MainView 
					data={ this.data }/>
			</Router>
		, mainContainer)
	}
}

const app = new Main()
app.init()


// WEBPACK FOOTER //
// ./src/index.js